<template>
  <switchStore 
    v-if="shopInfo"
    langCode_title="selectStore_title" 
    hideBackFlag 
    :shopInfo="shopInfo" 
    @action="handleSwitchStoreAction" 
  />
	<bk-view class="selectStorePage" v-else :loading="loadView==='view'"></bk-view>
</template>

<script>
	import switchStore from '@/pages/reserve/subViews/storeInfo/switchStore/switchStore.vue';
	import { shopReq, customerReq} from '@/reqService';

	export default {
		name: 'selectStore',
		components:{ switchStore },
		data () {
			return {
				loadView:'',
				shopInfo:null,
				query: this.$route.query,	
			};
		},
		mounted (){
			let token = this.$bk_getAccessToken();

			if (this.$bk_isNull(token)) {
				let that = this;
				window.viewCallback = function () {
					that.initData();
				};
				return;
			}
      
			this.initData();
		},
		methods:{
			async initData (){
				let { custId, compCode, silentMemberId} = this.query;

				if(!custId){
					return false;
				}

				let res = await shopReq.requestGetChainInfoByKeyword(this, { custId }).catch(() => {});
				
				if(['YK1'].includes(res?.custId) && silentMemberId){
					let curItem = res?.canReserveCompanyList?.find((cItem)=>{
						return cItem.compCode == compCode;
					});

					if(curItem?.id){
						this.handleSwitchStoreAction({ item: curItem });
						return false
					}
				}

				this.shopInfo = {
					custId:res.custId,
					canReserveCompanyList: res.canReserveCompanyList,
				};
			},
			async handleSwitchStoreAction ({ item }){
				const { custId, silentMemberId, memberId } = this.query

				let queryString = this.$bk_resvQueryString({
					memberId,
					custId,
					compId: item.id,
				});

				if(['YK1'].includes(custId) && silentMemberId){
					this.loadView = 'view'
					let res = await customerReq.requestTokenPasswordlessLogin(this,{ silentMemberId }).catch(()=>{})
					this.loadView = ''
					if(res){
						this.$bk_setAccessToken(res);
						window.reloadPath = `/shopDetail?${queryString}`;
						this.$router.push(`/index`);
						return false
					}
				}
				
				this.$router.replace(`/shopDetail?${queryString}`);

			}
		}
	};
</script>

<style lang="less">
@import './selectStore.less';
</style>